import { useSetAtom } from 'jotai';
import { createContext, useState } from 'react';
import { useUnmount } from 'react-use';

import { FormattedMessage } from '@flipster/i18n';
import { createSegmentedControl } from '@flipster/react/design-system/segmented-control';
import { css } from '@flipster/styled-system/css';
import { flex, stack } from '@flipster/styled-system/patterns';

import { pipChartDataAtom } from '@web/app/[locale]/(web)/trade/_misc/trade-pip/bunja';

import ChartTab from './ChartTab';
import PositionTab from './PositionTab';

export const TradePipSymbolContext = createContext<string>('dummy');
const SegmentedControl = createSegmentedControl<'chart' | 'position'>();

const TradePip = ({ symbol }: { symbol: string }) => {
  const [tab, setTab] = useState<'chart' | 'position'>('chart');

  const setChartData = useSetAtom(pipChartDataAtom);

  useUnmount(() => {
    // clear prev data
    setChartData([]);
  });

  return (
    <TradePipSymbolContext value={symbol}>
      <div className={stack({ h: '100vh', bgColor: 'background.default.level-0' })}>
        <div className={flex({ pt: 16, px: 16 })}>
          <SegmentedControl size='small' value={tab} css={{ width: 167 }} onChange={setTab}>
            <SegmentedControl.Item value='chart'>
              <div className={css({ textStyle: 'Text/S/Strong' })}>
                <FormattedMessage id='Autogen_common.r251126.s_Chart' />
              </div>
            </SegmentedControl.Item>
            <SegmentedControl.Item value='position'>
              <div className={css({ textStyle: 'Text/S/Strong' })}>
                <FormattedMessage id='Autogen_common.r251126.s_Position' />
              </div>
            </SegmentedControl.Item>
          </SegmentedControl>
        </div>
        <div className={css({ flex: 1, overflow: 'hidden' })}>
          {tab === 'chart' && <ChartTab />}
          {tab === 'position' && <PositionTab />}
        </div>
      </div>
    </TradePipSymbolContext>
  );
};

export default TradePip;
